/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Clubs_Remove_Confirm_TitleInputs */

const en_us2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
};

const pt_br2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}?`)
};

const es_419_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Quitar a ${i?.name}?`)
};

const pt_pt2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}?`)
};

const fr_fr2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.name} ?`)
};

const de_de2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernen?`)
};

const it_it2_clubs_remove_confirm_title = /** @type {(inputs: Clubs_Remove_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovere ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Clubs_Remove_Confirm_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_remove_confirm_title = /** @type {((inputs: Clubs_Remove_Confirm_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Remove_Confirm_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_remove_confirm_title(inputs)
	if (locale === "es-419") return es_419_clubs_remove_confirm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_remove_confirm_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_remove_confirm_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_remove_confirm_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_remove_confirm_title(inputs)
	return en_us2_clubs_remove_confirm_title(inputs)
});
export { clubs_remove_confirm_title as "clubs.remove_confirm_title" }